<template>
    <va-create-layout>
        <NetworkComminglingTransactionEvent-form
            :title="title"
            :item="item"
        ></NetworkComminglingTransactionEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
